/* Greens & Flowers thema: kern (menu, winkelwagen, productpagina) */
(() => {
  'use strict';
  const GF = window.GF = window.GF || {};
  const I = GF.i18n || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduce = !document.documentElement.classList.contains('motion');
  const money = (c) => {
    const v = (c / 100).toFixed(2).replace('.', ',');
    return (GF.moneyFormat || '€{{amount_with_comma_separator}}').replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v).replace(/<[^>]+>/g, '');
  };
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const json = (url, opt) => fetch(url, { headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, ...opt }).then((r) => { if (!r.ok) throw new Error(r.status); return r.json(); });
  const lockScroll = (on) => { document.body.style.overflow = on ? 'hidden' : ''; const l = GF.lenis; if (l) on ? l.stop() : l.start(); };
  GF.lockScroll = lockScroll;

  /* ---- Menu ---- */
  const rail = $('#rail'), scrim = $('#scrim'), openBtn = $('#menuOpen'), closeBtn = $('#menuClose');
  function setMenu(open) {
    if (!rail) return;
    rail.classList.toggle('is-open', open);
    scrim.hidden = !open;
    openBtn.setAttribute('aria-expanded', String(open));
    lockScroll(open);
    (open ? closeBtn : openBtn).focus({ preventScroll: true });
  }
  GF.closeMenu = () => setMenu(false);
  openBtn && openBtn.addEventListener('click', () => setMenu(true));
  closeBtn && closeBtn.addEventListener('click', () => setMenu(false));
  scrim && scrim.addEventListener('click', () => setMenu(false));

  /* ---- Winkelwagen ---- */
  const cartEl = $('#cart'), cartScrim = $('#cartScrim'), cartInner = $('#cartInner');
  const setCount = (n, bump) => $$('[data-cart-count]').forEach((el) => {
    el.textContent = n;
    if (bump && el.animate && !reduce) el.animate([{ transform: 'scale(1.35)' }, { transform: 'scale(1)' }], { duration: 400, easing: 'ease-out' });
  });
  function renderCart(cart) {
    setCount(cart.item_count);
    if (!cart.item_count) {
      cartInner.innerHTML = `<div class="cart-empty"><p>${I.cartEmpty}</p><a class="btn btn-primary" href="${GF.routes.all}">${I.viewPlants}</a></div>`;
      return;
    }
    const free = Math.round((GF.freeFrom || 49.99) * 100), left = free - cart.items_subtotal_price;
    cartInner.innerHTML = `<ul class="cart-lines">${cart.items.map((it) => `<li class="cart-line">
      <figure class="cart-thumb tone-sage">${it.image ? `<img src="${esc(it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2'))}" alt="">` : ''}</figure>
      <div class="cart-info"><a href="${esc(it.url)}"><strong>${esc(it.product_title)}</strong></a><span>${money(it.final_price)}</span>
        <div class="qty" role="group" aria-label="${esc(I.qty)}"><button type="button" data-qty="${it.key}" data-n="${it.quantity - 1}" aria-label="${esc(I.less)}">−</button><output>${it.quantity}</output><button type="button" data-qty="${it.key}" data-n="${it.quantity + 1}" aria-label="${esc(I.more)}">+</button></div></div>
      <div class="cart-end"><strong>${money(it.final_line_price)}</strong><button type="button" class="cart-rm" data-qty="${it.key}" data-n="0">${I.remove}</button></div></li>`).join('')}</ul>
      <div id="cartRec"></div><div class="cart-ship">${left <= 0 ? I.freeShip : `${(I.leftToFree || '').replace('__AMOUNT__', money(left))}<span class="ship-bar" style="--v:${Math.round((cart.items_subtotal_price / free) * 100)}"><i></i></span>`}</div>
      <dl class="cart-total"><div><dt>${I.subtotal}</dt><dd>${money(cart.items_subtotal_price)}</dd></div><div><dt>${I.shipping}</dt><dd>${left <= 0 ? I.free : I.atCheckout}</dd></div><div class="grand"><dt>${I.total}</dt><dd>${money(cart.total_price)}</dd></div></dl>
      <a class="btn btn-primary cart-pay" href="/checkout">${I.checkout}</a>
      <p class="cart-methods"><span>${I.payWith}</span> <b>Wero</b> <b>Visa</b> <b>Mastercard</b> <b>American Express</b></p>`;
    cartRec(cart);
  }
  async function cartRec(cart) {
    const box = $('#cartRec'); if (!box || !cart.items.length) return;
    try {
      const pid = cart.items[0].product_id;
      const r = await json(`${GF.root || '/'}recommendations/products.json?product_id=${pid}&limit=4&intent=related`);
      const inCart = new Set(cart.items.map((i) => i.product_id));
      const p = (r.products || []).find((x) => !inCart.has(x.id) && x.available);
      if (!p) return;
      const img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
      box.innerHTML = `<div class="cart-rec"><h3>${I.goesWell}</h3><a href="${esc(p.url)}">${img ? `<img src="${esc(img)}" alt="" loading="lazy" width="64" height="64">` : '<i></i>'}<strong>${esc(p.title)}</strong><span>${money(Math.round(parseFloat(p.price) * (String(p.price).includes('.') ? 100 : 1)))}</span></a></div>`;
    } catch (e) { /* geen aanbeveling */ }
  }
  const loadCart = () => json(GF.routes.cartJs).then((c) => { renderCart(c); return c; });
  function setCart(open) {
    if (!cartEl) return;
    if (open) loadCart().catch(() => {});
    cartEl.classList.toggle('is-open', open);
    cartEl.setAttribute('aria-hidden', String(!open));
    cartScrim.hidden = !open;
    lockScroll(open);
    if (open) $('#cartClose').focus({ preventScroll: true });
  }
  GF.closeCart = () => setCart(false);
  async function add(variant, btn, qty) {
    const label = btn && btn.textContent;
    if (btn) btn.disabled = true;
    try {
      await json(GF.routes.add + '.js', { method: 'POST', body: JSON.stringify({ items: [{ id: Number(variant), quantity: Math.max(1, Number(qty) || 1) }] }) });
      const c = await loadCart();
      setCount(c.item_count, true);
      if (btn) { btn.textContent = I.added; btn.classList.add('is-added'); setTimeout(() => { btn.textContent = label; btn.classList.remove('is-added'); btn.disabled = false; }, 1400); }
      setTimeout(() => setCart(true), 300);
    } catch (e) {
      if (btn) { btn.textContent = I.unavailable; setTimeout(() => { btn.textContent = label; btn.disabled = false; }, 1800); }
    }
  }

  /* ---- Productgalerij ---- */
  function galIndex() { const f = $$('.pdp-main [data-slot]').find((x) => !x.hidden); return f ? Number(f.dataset.slot) : 0; }
  function galGo(n) {
    const slots = $$('.pdp-main [data-slot]'); if (!slots.length) return;
    const i = (n + slots.length) % slots.length;
    slots.forEach((f) => (f.hidden = Number(f.dataset.slot) !== i));
    $$('[data-thumb]').forEach((b) => b.setAttribute('aria-selected', String(Number(b.dataset.thumb) === i)));
    const now = $('[data-gal-now]'); if (now) now.textContent = String(i + 1);
  }
  (function pdpExtras() {
    const z = $('[data-zoom]');
    if (z && window.matchMedia('(hover: hover)').matches) {
      z.addEventListener('mousemove', (e) => { const r = z.getBoundingClientRect(); z.style.setProperty('--zx', ((e.clientX - r.left) / r.width) * 100 + '%'); z.style.setProperty('--zy', ((e.clientY - r.top) / r.height) * 100 + '%'); });
    }
    if (z) {
      let x0 = null;
      z.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
      z.addEventListener('touchend', (e) => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) > 45) galGo(galIndex() + (dx < 0 ? 1 : -1)); }, { passive: true });
    }
    document.addEventListener('keydown', (e) => { if (!z) return; if (e.key === 'ArrowRight' && z.matches(':hover, :focus-within')) galGo(galIndex() + 1); if (e.key === 'ArrowLeft' && z.matches(':hover, :focus-within')) galGo(galIndex() - 1); });
    const c = $('[data-clamp]'); const b = $('[data-clamp-btn]');
    if (c && b && c.scrollHeight > c.clientHeight + 4) b.hidden = false; else if (c) c.classList.remove('is-clamp');
  })();

  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-add]');
    if (a) { e.preventDefault(); add(a.dataset.variant, a); return; }
    const o = e.target.closest('[data-cart-open]');
    if (o && cartEl) { e.preventDefault(); setCart(true); return; }
    if (e.target.closest('[data-cart-close]') || e.target === cartScrim) { setCart(false); return; }
    const q = e.target.closest('[data-qty]');
    if (q) json(GF.routes.change + '.js', { method: 'POST', body: JSON.stringify({ id: q.dataset.qty, quantity: Number(q.dataset.n) }) }).then(renderCart);
    const ft = e.target.closest('[data-filt-toggle]');
    if (ft) { const f = $('#filters'); const on = !f.classList.contains('is-open'); f.classList.toggle('is-open', on); ft.setAttribute('aria-expanded', String(on)); }
    const th = e.target.closest('[data-thumb]');
    if (th) galGo(Number(th.dataset.thumb));
    const gs = e.target.closest('[data-gal-step]');
    if (gs) galGo(galIndex() + Number(gs.dataset.galStep));
    const sh = e.target.closest('[data-share]');
    if (sh) {
      const url = location.href.split('#')[0];
      if (navigator.share) { navigator.share({ title: sh.dataset.title, url }).catch(() => {}); }
      else if (navigator.clipboard) { navigator.clipboard.writeText(url).then(() => { sh.setAttribute('aria-label', I.linkCopied); sh.classList.add('is-done'); setTimeout(() => { sh.classList.remove('is-done'); sh.setAttribute('aria-label', I.share); }, 2000); }).catch(() => {}); }
    }
    const cb = e.target.closest('[data-clamp-btn]');
    if (cb) { const t = cb.previousElementSibling; const open = t.classList.toggle('is-clamp'); cb.textContent = open ? I.readMore : I.showLess; }
    const rc = e.target.closest('[data-recover]');
    if (rc) { e.preventDefault(); $('#recover').hidden = false; }
    const ea = e.target.closest('[data-edit-addr]');
    if (ea) { const box = $('#addr-' + ea.dataset.editAddr); box.hidden = !box.hidden; }
    const da = e.target.closest('[data-del-addr]');
    if (da && window.confirm(I.deleteAddress)) { const f = document.createElement('form'); f.method = 'post'; f.action = da.dataset.url; f.innerHTML = '<input type="hidden" name="_method" value="delete">'; document.body.appendChild(f); f.submit(); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (cartEl && cartEl.classList.contains('is-open')) setCart(false);
    if (rail && rail.classList.contains('is-open')) setMenu(false);
  });
  document.addEventListener('change', (e) => { if (e.target.matches('[data-sort]')) { const u = new URL(location.href); u.searchParams.set('sort_by', e.target.value); u.searchParams.delete('page'); location.href = u; } });
  const pf = $('[data-pdp-form]');
  if (pf) pf.addEventListener('submit', (e) => { e.preventDefault(); add(new FormData(pf).get('id'), $('[data-pdp-add]', pf), new FormData(pf).get('quantity')); });
  document.addEventListener('click', (e) => { const st = e.target.closest('[data-qty-step]'); if (!st) return; const qi = $('[data-pdp-qty]'); if (qi) qi.value = Math.min(20, Math.max(1, (Number(qi.value) || 1) + Number(st.dataset.qtyStep))); });
  const shp = $('[data-ship]');
  if (shp) { const p = Number(shp.dataset.price), f = Math.round((GF.freeFrom || 49.99) * 100); shp.innerHTML = p >= f ? I.freeShip : `${(I.leftToFree || '').replace('__AMOUNT__', money(f - p))}<span class="ship-bar" style="--v:${Math.round((p / f) * 100)}"><i></i></span>`; }
  GF.util = { $, $$, money, esc, json };
})();